<template>

  <svg
    t="1639131221200"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3988"
    width="64"
    height="64"
  ><path d="M814.22685547 155.53935547c0 20.61123047-16.70888672 37.32099609-37.32099609 37.32099609H240.80029297c-20.61035156 0-37.32099609-16.70888672-37.3209961-37.32099609 0-20.61123047 16.70888672-37.32099609 37.3209961-37.32099609h536.1055664c20.61210937 0 37.32099609 16.70800781 37.3209961 37.32099609zM511.84707031 294.33886719c-20.61123047 0-37.32099609 16.70800781-37.32099609 37.32099608v536.10468751c0 20.61123047 16.70800781 37.32099609 37.32099609 37.3209961 20.61123047 0 37.32099609-16.70800781 37.3209961-37.3209961v-536.10644531c0-20.61035156-16.70976562-37.31923828-37.3209961-37.31923828z m26.48583986-27.534375c-14.57402345-14.57402345-37.36845703-15.41074219-50.91240236-1.86679688l-274.90429687 274.90429688c-13.54394531 13.5421875-12.70810547 36.33662109 1.86679687 50.91152343 14.57402345 14.57402345 37.36845703 15.41074219 50.91152344 1.86679688l274.90605469-274.90429688c13.54306641-13.5421875 12.70722656-36.33662109-1.86767577-50.91152343z m-52.96640626 0c-14.57490234 14.57490234-15.41162109 37.36933594-1.86767579 50.91152343L758.40400391 592.62207031c13.54394531 13.54394531 36.3375 12.70722656 50.91152343-1.86679687 14.57490234-14.57490234 15.41162109-37.36933594 1.86767579-50.91152345l-274.90429688-274.90605468c-13.54394531-13.54394531-36.3375-12.70634766-50.91240234 1.86767578z" p-id="3989" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMoveTop',
} as DefineComponent
</script>